module.exports = __webpack_public_path__ + "img/salchipapas_revoltosa.275ff5d6.jpeg";